export default __webpack_public_path__ + "static/media/d3.22f30f1b.jpg";